import React, { useContext } from 'react';
import { OnboardingStep2 } from './OnboardingStep2';
import styled from 'styled-components';
import { UpdateWorkspace } from '../../../../shared/types/workspaceTypes';
import { OnboardingStep1 } from './OnboardingStep1';
import { useTrack } from '@hackler/react-sdk';
import { postCreateCompany } from '../../../../common/api/apiClient';
import { AppContext } from '../../../../App';

interface Props {
  data: UpdateWorkspace;
  step: number;
  setStep: (step: number) => void;
  onChange: (data: UpdateWorkspace) => void;
  onPrev: () => void;
}

export const OnboardingPc: React.FC<Props> = ({ data, step, setStep, onChange, onPrev }) => {
  const { redirect } = useContext(AppContext);
  const track = useTrack();

  const handlePrev = () => {
    track({ key: `click_step${step}_back` });
    if (step > 1) {
      setStep(step - 1);
    } else {
      onPrev();
    }
  };

  const handleSubmit = () => {
    postCreateCompany(
      {
        name: data.name,
        officer_contact: data.contact.officer_contact,
        address: data.location.address,
        address_detail: data.location.address_detail,
        x: String(data.location.x),
        y: String(data.location.y),
        zoom_lv: data.location.zoom_lv,
        parking: data.location.parking,
        signature: data.tree_signature,
      },
      redirect,
    );
  };

  return (
    <Container>
      <Wrapper>
        {step === 1 && (
          <OnboardingStep1
            data={data}
            onChange={onChange}
            onPrev={handlePrev}
            onNext={() => {
              track({ key: 'click_step1_next' });
              setStep(2);
            }}
          />
        )}
        {step === 2 && <OnboardingStep2 data={data} onChange={onChange} onPrev={handlePrev} onNext={handleSubmit} />}
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  top: 9rem;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: calc(100vh - 9rem);
  background-color: var(--background-1);
  overflow-y: auto;
  z-index: 1;
`;

const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  max-width: 144rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;
